import React from 'react';
import { Modal } from 'reactstrap';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SMLPublishedSheet } from './SMLPublishedSheet';
import styles from './SMLPublishedModal.module.scss';

interface SMLPublishedModalProps {
  isOpen: boolean;
  accountId: number;
  smartLink: SerializedSmartLink;
  closeModal: () => void;
  openSmartLink: () => void;
}

/**
 * The sheet's shell.
 *
 * The body is mounted only while the sheet is open: it reads the campaign, the
 * account and the catalog, and none of that is worth fetching for a sheet
 * nobody has opened.
 */
const SMLPublishedModalComponent: React.FC<SMLPublishedModalProps> = ({
  isOpen,
  accountId,
  smartLink,
  closeModal,
  openSmartLink,
}) => (
  <Modal isOpen={isOpen} toggle={closeModal} centered className={styles.dialog} contentClassName={styles.sheet}>
    {isOpen && (
      <SMLPublishedSheet
        accountId={accountId}
        smartLink={smartLink}
        closeModal={closeModal}
        openSmartLink={openSmartLink}
      />
    )}
  </Modal>
);

export const SMLPublishedModal = TypedMemo(SMLPublishedModalComponent);
